export type DismissedPopupKeywords =
  | 'm_app_children_portfolio'
  | 'm_app_demo'
  | 'm_app_management'
  | 'm_app_pap'
  | 'm_app_settings'
  | 'pap_app_initial'
  | 'pap_app_demo'
  | 't_app_initial';
